import React from "react"

import { Tooltip, useClipboard } from "@chakra-ui/react"

type ComponentProps = {
  onClick: (event: React.MouseEvent<any>) => void
}

type CopyToClipboardProps = {
  text: string
  label?: string
  showCopiedValue?: boolean
}

export const withCopyToClipboard = <T extends ComponentProps>(
  Component: React.ComponentType<T>,
) => {
  return function ({
    text,
    label,
    showCopiedValue,
    ...props
  }: T & CopyToClipboardProps) {
    const { hasCopied, onCopy } = useClipboard(text)
    const newProps = {
      ...props,
      onClick: (event: React.MouseEvent<any>) => {
        event.stopPropagation()
        onCopy()
      },
    } as unknown as T
    return (
      <Tooltip
        label={
          hasCopied
            ? showCopiedValue
              ? `${text} copied!`
              : "Copied!"
            : label || "Copy to clipboard"
        }
        shouldWrapChildren
        mt={2}
        ml={5}
      >
        <Component {...newProps} />
      </Tooltip>
    )
  }
}
